export const AttributeTypes = {
  lead_label: 'lead_label',
  company_pattern: 'company_pattern',
  branch: 'branch',
  classification_code: 'classification_code',
  company_size: 'company_size',
  country: 'country',
  campaign: 'campaign',
  zip_code: 'zip_code',
  duration: 'duration',
  returned_visitor: 'returned_visitor',
  source: 'source',
  referrer: 'referrer',
  page_group: 'page_group',
  country_group: 'country_group',
  file_download: 'file_download',
  email_click: 'email_click',
  phone_click: 'phone_click',
  form_submit: 'form_submit',
  isp: 'isp',
  hidden: 'hidden',
};
Object.freeze(AttributeTypes);

export const Operators = {
  eq: 'eq',
  contains: 'contains',
  starts_with: 'starts_with',
  ends_with: 'ends_with',
  gte: 'gte',
  lte: 'lte',
  range: 'range',
  regexp: 'regexp',
};
Object.freeze(Operators);

export const Conditions = {
  and: 'and',
  or: 'or',
};
Object.freeze(Conditions);

export const AttributesOptions = [
  {
    type: AttributeTypes.lead_label,
    operators: ['eq'],
    conditions: ['or', 'and'],
  },
  {
    type: AttributeTypes.company_pattern,
    operators: ['eq', 'contains', 'starts_with', 'ends_with', 'regexp'],
    conditions: ['or', 'and'],
  },
  {
    type: AttributeTypes.branch,
    operators: ['eq'],
    conditions: ['or', 'and'],
  },
  {
    type: AttributeTypes.classification_code,
    operators: ['eq'],
    conditions: ['or', 'and'],
  },
  {
    type: AttributeTypes.company_size,
    operators: [Operators.range, Operators.gte, Operators.lte],
    conditions: [Conditions.or],
  },
  {
    type: AttributeTypes.country,
    operators: ['eq'],
    conditions: ['or'],
  },
  {
    type: AttributeTypes.campaign,
    operators: ['eq'],
    conditions: ['and', 'or'],
  },
  {
    type: AttributeTypes.zip_code,
    operators: ['range', 'starts_with', 'contains'],
    conditions: ['or', 'and'],
  },
  {
    type: AttributeTypes.duration,
    operators: [Operators.range, Operators.gte, Operators.lte],
    conditions: [Conditions.or],
  },
  {
    type: AttributeTypes.returned_visitor,
    operators: [Operators.range, Operators.gte, Operators.lte],
    conditions: ['or'],
  },
  {
    type: AttributeTypes.source,
    operators: ['eq'],
    conditions: ['or'],
  },
  {
    type: AttributeTypes.referrer,
    operators: ['eq', 'starts_with'],
    conditions: ['or'],
  },
  {
    type: AttributeTypes.page_group,
    operators: ['eq'],
    conditions: ['or'],
  },
  {
    type: AttributeTypes.country_group,
    operators: ['eq'],
    conditions: ['or'],
  },
  {
    type: AttributeTypes.file_download,
    operators: ['eq', 'starts_with', 'ends_with', 'contains'],
    conditions: ['or', 'and'],
  },
  {
    type: AttributeTypes.email_click,
    operators: ['eq'],
    conditions: ['and'],
  },
  {
    type: AttributeTypes.phone_click,
    operators: ['eq'],
    conditions: ['and'],
  },
  {
    type: AttributeTypes.form_submit,
    operators: ['eq'],
    conditions: ['and'],
  },
  {
    type: AttributeTypes.isp,
    operators: ['eq'],
    conditions: ['and'],
  },
  {
    type: AttributeTypes.hidden,
    operators: ['eq'],
    conditions: ['and'],
  },
];

Object.freeze(AttributesOptions);

export const Campaigns = {
  direct: 'direct',
  campaign: 'campaign',
  search: 'search',
  social: 'social',
  website: 'website',
};
Object.freeze(Campaigns);


export const Assertions = {
  is: 'is',
  not: 'not',
};

Object.freeze(Assertions);

export default { AttributesOptions, AttributeTypes, Campaigns, Operators, Conditions, Assertions };



// WEBPACK FOOTER //
// ./src/components/LeadScoring/LeadScoringAttributeTypeSelector/Attributes.js